<template>
  <bcq-app id="app" :dark="$root.dark">
    <toolbar app tag="header" color="white" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness">
      <toolbar-icon>
        <icon @click="$root.navbar.collapsed = !$root.navbar.collapsed" name="menu" color="white" :title="$lang.toggleNavigation" :class="['cursor-pointer']" />
      </toolbar-icon>
      <toolbar-title :text="$config.appName" />
      <app-toolbar-actions />
    </toolbar>
    <navbar @resize="onNabvarResize" v-model="$root.navbar.collapsed" :right="$root.navbar.right" :floating="$root.navbar.floating" :temporary="$root.navbar.temporary">
      <avatar to="/" tag="router-link" size="88px" color="white" font-size="xl" elevation="lg" :title="$lang.home" :bg-color="$root.colors.primary" :text="$config.appNameAbbr" :color-lightness="null" :class="['m-auto', 'my-6', 'hidden', 'md:block']" :bg-color-lightness="$root.colors.bgColorLightness" />
      <search-form :class="['mb-4']" />
      <app-color-switcher name="navbar-color-switcher" :class="['mb-4']" />
      <navigation />
      <prev-next />
    </navbar>
    <app-main>
      <h1 :class="['text-3xl', 'my-4']" v-html="$config.appDescription" />
      <page-meta />
      <container :class="['pb-8']">
        <alert v-model="mobileMessage" v-if="!mobileMessageCookie" @dismiss="onCookieDismiss" type="info" :class="['lg:hidden', 'mr-2', 'mb-4']">{{ $lang.mobileMessage }}</alert>
        <router-view />
        <api-explorer :tab-height="$root.config.apiExplorerTabHeight" :title="$lang.documentationFor(getPageTitle())" :dense="false" :class="['my-8', 'mr-2']" name="bcq-explorer" color="white" :color-lightness="null" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" />
        <browse-code />
        <badges :class="['mt-8']" />
      </container>
    </app-main>
    <app-footer />
    <cookie-consent @cookie-policy-btn-click="$router.push({path: '/cookie-policy'})" v-model="$root.cookieConsent" cookie-policy-btn-to="/cookie-policy" :btn-bg-color="$root.colors.primary" :btn-bg-color-lightness="$root.colors.bgColorLightness" btn-color="white">
      {{ $lang.weUseCookies }}
    </cookie-consent>
    <loading-overlay :visible="$root.ajax" :spinner-color="$root.colors.primary" :spinner-color-lightness="$root.colors.bgColorLightness" />
    <fab :class="[$root.fab.visible ? ['opacity-100'] : ['opacity-0', 'pointer-events-none'], 'transition-all', 'duration-500']" @click="onFabClick" color="white" bottom="5rem" size="lg" :bg-color="$root.colors.primary" :title="$lang.scrollToTop" :bg-color-lightness="$root.colors.bgColorLightness" :color-lightness="null" />
    <nightshift :visible="$root.nightShift" />
    <code-viewer />
    <device-emulator :url="$root.currentLocation" />
  </bcq-app>
</template>
<script>
import methods from './mixins/methods'
import Cookies from 'universal-cookie'

export default {
  name: 'App',
  mixins: [
    methods
  ],
  data () {
    return {
      mobileMessage: true,
      mobileBreakpoint: 1024,
      mobileMessageCookie: new Cookies().get(this.$config.mobileMessageCookie)
    }
  },
  mounted () {
    this.onMounted()
  },
  methods: {
    onMounted () {
      this.expandCurrentSection()
    },
    getPageTitle () {
      const slug = this.pathSplit().pop()
      const route = this.$router.options.routes.find(route => route.name === `page-${slug}`)
      return route ? route.title : null
    },
    onNabvarResize ($event) {
      const viewportWidth = $event.width
      const mobileBreakpoint = this.mobileBreakpoint
      this.$root.navbar = {
        collapsed: viewportWidth <= mobileBreakpoint,
        temporary: viewportWidth <= mobileBreakpoint,
        floating: viewportWidth <= mobileBreakpoint
      }
    },
    onFabClick () {
      this.scrollToTop()
    },
    expandCurrentSection () {
      const path = this.pathSplit()
      const section = path[1] !== '' ? path[1] : 'getting-started'
      const sections = Object.keys(this.$lang.sections)
      this.$root.selectedSectionIndex = sections.findIndex(item => item === section)
    },
    onCookieDismiss () {
      const cookies = new Cookies()
      cookies.set(this.$config.mobileMessageCookie, true, {
        path: '/',
        expires: this.oneMonthFromNow()
      })
      this.$root.cookieConsent = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app.vue